module.exports = __webpack_public_path__ + "static/media/menu-highlight.4ec6362b.svg";